import type {
  Medication,
  MedicationDetails,
} from '../../../../lib/transferObjects/Medication';
import type {
  DoctorLetterForm,
  PharmacistLetterForm,
} from '../components/Letters/types';

export type MedProfileStatus =
  | 'in progress'
  | 'finalised'
  | 'entered in error'
  | 'consumer created';

export enum MedProfileStatusEnum {
  IN_PROGRESS = 'in progress',
  FINALISED = 'finalised',
  ENTERED_IN_ERROR = 'entered in error',
  CONSUMER_CREATED = 'consumer created',
}

export type UpdatePatientMedProfilePayload = {
  access_token: string;
  tenancyId: number;
  medProfile: {
    id?: string | null;
    profileStatus: MedProfileStatus;
    pharmacist?: string;
    pdfOptions?: PdfOptions;
    appointments?: Appointment[];
    medSections: MedSection[];
    pharmacistLetter?: PharmacistLetterForm;
    doctorLetter?: DoctorLetterForm;
  };
};

export interface MedProfile {
  id: string;
  caremapprId: string;
  createdTenancyId: number;
  profileStatus: MedProfileStatus;
  clientClinicEpisodeId: number;
  pharmacist?: string;
  finalisedBy?: string;
  finalisedDate?: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  pdfOptions?: PdfOptions;
  appointments?: Appointment[];
  medSections: MedSection[];
  isCurrent: boolean;
  pharmacistLetter?: PharmacistLetterForm;
  doctorLetter?: DoctorLetterForm;
  hospitalVerified: boolean;
  healthProviderVerified: boolean;
}

export interface PdfOptions {
  isViewTime?: boolean;
  isViewIcon?: boolean;
  isDrLetterIncluded?: boolean;
  isPharmLetterIncluded?: boolean;
  isLargeFontSize?: boolean;
  isSubheadingIncluded?: boolean;
  extraRows?: number;
}

export interface Appointment {
  apptType: string;
  apptDate?: string;
  apptTime?: string;
}

export interface MedSection {
  order?: number;
  medSectionBreak: string;
  medications: Partial<Medication>[];
}

interface CatalogMedicationDetailsRegimen {
  doseSchedule: {
    bedNote?: string;
    breakfastNote?: string;
    dinnerNote?: string;
    isBed: boolean;
    isBreakfast: boolean;
    isDinner: boolean;
    isLunch: boolean;
    lunchNote?: string;
  };
  isDoseSchedule: boolean;
}
interface CatalogMedicationDetails {
  brand: string;
  furtherInformation?: string;
  indication?: string;
  indicationDescription?: string;
  medChangeType?: string;
  medName?: string;
  medSectionBreak?: string;
  regimen: CatalogMedicationDetailsRegimen;
  sortId: number;
  subheading?: string;
}
interface CatalogMedication {
  createdAt: string;
  deletedAt?: string;
  id: number;
  medId: number;
  updatedAt?: string;
  details: CatalogMedicationDetails;
}
export interface CatalogOrderSet {
  createdAt: string;
  deletedAt?: string;
  id: number;
  isActive: boolean;
  note?: string;
  orderSetName: string;
  tenancyId: number;
  updatedAt?: string;
  medications: CatalogMedication[];
}
// Using central MedicationDetails type from lib/transferObjects/Medication
export type UpdateCatalogOrderSetPayload = {
  orderSetId: number | null;
  orderSetName?: string;
  isActive?: boolean;
  isDeleted?: boolean;
  note?: string | null;
  tenancyId: number;
  medications?: MedicationDetails[];
};

export enum ViewMode {
  PREVIEW = 'preview',
  DOWNLOAD = 'download',
}
